
import React from 'react';
import { render } from 'react-dom';
import { baseURL } from '../API/url';
import Profile from './profileAdvisor';
import Clients from './portfolioAdvisor';
import PortfolioEMD from './portfolioEMD';
import PortfolioAdmin from './portfolioAdmin';
import Login from './loginAdvisor';
import Register from './registerAdvisor';
import ChangeProfile from './changeProfile';
import ChatbotWidget from './chatbotWidget';
import '../App.css';
import NavBar from './NavBar/NavBar';
import SideBar from './SideBar/SideBar';
import { sessionManager, setupAxiosInterceptors } from '../utils/sessionManager';


import {
	BrowserRouter,
  	Route,
  	Link,
  	Switch,
  	Redirect
} from 'react-router-dom'
import ResetPassword from './resetPassword';
import axios from 'axios';
import { Layout, Menu, Typography } from 'antd';
import logo from '../image/ginkgo_logo.jpg';

const { Header, Content, Footer, Sider } = Layout;
const { SubMenu,Item } = Menu;

class App extends React.Component<any,any> {

	constructor(props:any) {
		super(props);
		this.state = { 
			isAuthenticated: false, 
			currentUser: '', 
			userType: null,
			loading: true // Add loading state
		};
	}

	// Route wrapper components to prevent unnecessary re-renders
	renderEMDPortfolio = () => {
		const timestamp = new Date().toISOString();
		console.log(`[${timestamp}] Route "/emd-portfolio" being rendered - isAuthenticated:`, this.state.isAuthenticated, 'userType:', this.state.userType);
		console.log(`[${timestamp}] Render call stack:`, new Error().stack);
		return <PortfolioEMD isAuthenticated={[this.state.isAuthenticated, this.state.currentUser]} />;
	}

	renderAdminPortfolio = () => {
		const timestamp = new Date().toISOString();
		console.log(`[${timestamp}] Route "/admin-portfolio" being rendered - isAuthenticated:`, this.state.isAuthenticated, 'userType:', this.state.userType);
		return <PortfolioAdmin isAuthenticated={[this.state.isAuthenticated, this.state.currentUser]} />;
	}

	renderClients = () => {
		const timestamp = new Date().toISOString();
		console.log(`[${timestamp}] Route "/clients" being rendered - isAuthenticated:`, this.state.isAuthenticated, 'userType:', this.state.userType);
		return <Clients isAuthenticated={[this.state.isAuthenticated, this.state.currentUser]} />;
	}

	// Cookie utility functions
	getCookie = (name: string): string | null => {
		const nameEQ = name + "=";
		const ca = document.cookie.split(';');
		for(let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	}

	deleteCookie = (name: string) => {
		document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
	}
	componentDidMount = async() =>{	
		console.log('App componentDidMount - checking authentication');
		
		// Setup axios interceptors for session management
		setupAxiosInterceptors(axios);
		
		const isAuthenticated = await this.checkAuth()
		console.log('Authentication result:', isAuthenticated);
		
		if (isAuthenticated) {
			console.log('Setting state - userType:', isAuthenticated.userType);
			this.setState({
				isAuthenticated: true, 
				currentUser: isAuthenticated.email,
				userType: isAuthenticated.userType,
				loading: false
			});
		} else {
			this.setState({
				isAuthenticated: false,
				currentUser: '',
				userType: null,
				loading: false
			});
		}
		console.log('App state after auth check:', this.state);
	}

	checkAuth = async() =>{
		try {
			// Check if session is valid using session manager
			if (!sessionManager.isSessionValid()) {
				console.log('No valid session found');
				return false;
			}

			console.log('Valid session found, validating with server');
			
			// Validate session with server
			const response = await axios.post(baseURL + "/auth/validate-session");
			console.log('Session validation response:', response.data);
			
			if (response.data && response.data.valid && response.data.user) {
				const userData = {
					email: response.data.user.email,
					userType: response.data.user.userType,
					id: response.data.user.id
				};
				console.log('checkAuth: Returning user data:', userData);
				return userData;
			}
			
			console.log('checkAuth: Invalid response data, returning false');
			return false;
		} catch (error: any) {
			console.log('Session validation failed:', error);
			
			// Only clear session if it's a 401 (unauthorized), not for network errors
			if (error.response && error.response.status === 401) {
				console.log('Clearing invalid session due to 401 error');
				sessionManager.clearSession();
			} else {
				console.log('Session validation failed due to network or other error, keeping session');
			}
			
			return false;
		}
	}
	
	setAuthenticate = (bool: boolean, userType?: string) => {
		console.log('setAuthenticate called with:', bool, 'userType:', userType);
		this.setState({
			isAuthenticated: bool,
			userType: userType || this.state.userType, // Use provided userType or keep existing
			loading: false // Ensure loading is false when authentication state is set
		});
		
		// Don't refresh auth data here - it should be called explicitly when needed
		// This prevents redundant API calls when setCurrentUser already called refreshAuthData
	}

	refreshAuthData = async () => {
		try {
			console.log('refreshAuthData: Starting auth data refresh...');
			const authData = await this.checkAuth();
			if (authData) {
				console.log('refreshAuthData: Auth data received:', authData);
				console.log('refreshAuthData: Setting userType to:', authData.userType);
				this.setState({
					isAuthenticated: true,
					currentUser: authData.email,
					userType: authData.userType,
					loading: false
				});
				console.log('refreshAuthData: State updated. New state will be:', {
					isAuthenticated: true,
					currentUser: authData.email,
					userType: authData.userType,
					loading: false
				});
			} else {
				console.log('refreshAuthData: No auth data received');
			}
		} catch (error) {
			console.log('Failed to refresh auth data:', error);
		}
	}


	setCurrentUser = async (email: string) => {
		console.log('setCurrentUser called with:', email);
		this.setState({currentUser: email });
		
		// Only refresh auth data if we don't already have the userType
		// This prevents redundant API calls during login flow
		if (!this.state.userType) {
			console.log('No userType found, refreshing auth data...');
			await this.refreshAuthData();
		} else {
			console.log('UserType already available:', this.state.userType, '- skipping auth refresh');
		}
	}

	// Method to set both authentication and user in a single state update
	setAuthenticationState = (isAuthenticated: boolean, userEmail: string, userType: string) => {
		const timestamp = new Date().toISOString();
		console.log(`[${timestamp}] setAuthenticationState called with:`, { isAuthenticated, userEmail, userType });
		console.log(`[${timestamp}] Previous state:`, { 
			isAuthenticated: this.state.isAuthenticated, 
			currentUser: this.state.currentUser, 
			userType: this.state.userType 
		});
		this.setState({
			isAuthenticated,
			currentUser: userEmail,
			userType,
			loading: false
		}, () => {
			console.log(`[${timestamp}] State updated successfully:`, {
				isAuthenticated: this.state.isAuthenticated,
				currentUser: this.state.currentUser,
				userType: this.state.userType
			});
		});
	}

	handleDashboardClick = () => {
		const { userType } = this.state;
		console.log('Dashboard clicked - userType:', userType);
		
		if (userType === 'emd') {
			window.location.assign('/emd-portfolio');
		} else if (userType === 'admin') {
			window.location.assign('/admin-portfolio');
		} else {
			window.location.assign('/clients');
		}
	}

	Menu = () =>(
		<Menu
		className="nav"
		defaultOpenKeys={['0', '1']}
		mode="inline"
		//mode="horizontal"
	>
		<SubMenu key="0" title={
			<span><i className="anticon anticon-home" /> Home</span>
		}>
			{!this.state.isAuthenticated ? (
				<Item key="0.0">
					<Link to='/login' replace ><i className="anticon anticon-home"/> Login</Link>
				</Item>
			) : (
				<Item key="0.1">
					<a onClick={ async ()=>{
						console.log('Logout clicked');
						this.setState({isAuthenticated: false, currentUser: '', userType: null });
						
						// Use session manager logout
						await sessionManager.logout();
					}}>						
					<i className="anticon anticon-home" /> Logout
					</a>
				</Item>
			)}
		</SubMenu>	

{
	this.state.isAuthenticated && this.state.userType !== null &&
	<Menu.Item key="1">
		<a onClick={this.handleDashboardClick}>
			<i className="anticon anticon-dashboard"/> Dashboard
		</a>
	</Menu.Item>
}

{/* {
	this.state.isAuthenticated && this.state.userType === 'emd' &&
	<Menu.Item key="2">
		<Link to="/emd-portfolio" replace ><i className="anticon anticon-home"/> EMD Dashboard</Link>
	</Menu.Item>
}

{
	this.state.isAuthenticated && this.state.userType === 'advisor' &&
	<Menu.Item key="3">
		<Link to="/clients" replace ><i className="anticon anticon-home"/> Clients</Link>
	</Menu.Item>
 */}

{
	this.state.isAuthenticated &&
	<Menu.Item key="4">
		<Typography.Link href="https://ginkgomic.com/investor/events/" target="_blank"><i className="anticon anticon-home"/> News</Typography.Link>
	</Menu.Item>
}

{
	this.state.isAuthenticated &&
		<SubMenu key="5" title={
			<span><i className="anticon anticon-team" /> Forms</span>
		}>
			<SubMenu key="5.2" title={
				<span><i className="anticon anticon-team" />Ginkgo</span>
			}>
				<Item key="5.2.0">
				<	Typography.Link href="https://ginkgomic.sharepoint.com/:b:/g/IQDRE4LAUWG9QZfkOOfsebSYAc8_xCTkqSS6Kc62nwnVikI" target="_blank"><i className="anticon anticon-home"/>Distribution Option</Typography.Link>
				</Item>
				<Item key="5.2.1">
				<	Typography.Link href="https://ginkgomic.sharepoint.com/:b:/g/IQC1zqfZmUzgSp0ieqDi-VqAAaJwvyWhF7TgommkjJdMrJI?e=FU7xpE" target="_blank"><i className="anticon anticon-home"/>Redemption</Typography.Link>
				</Item>
				<Item key="5.2.2">
				<	Typography.Link href="https://ginkgomic.sharepoint.com/:b:/g/Ecc8WELBfltEjuLdFBv84EsBEskRTpOYertjDO36Z-gALw?e=M5fkGj" target="_blank"><i className="anticon anticon-home"/>OM</Typography.Link>
				</Item>
			</SubMenu> 

{/*				<Item key="2.0">
				<	Typography.Link href="https://ias.olympiatrust.com/forms" target="_blank"><i className="anticon anticon-home"/>Olympia Trust Company</Typography.Link>
				</Item>
{/* 				<Item key="2.1">
				<	Typography.Link href="https://www-us.computershare.com/Investor/#Help/PrintableForms" target="_blank"><i className="anticon anticon-home"/>Computershare</Typography.Link>
				</Item>
 */}		</SubMenu> 
}

{/* {
	this.state.isAuthenticated &&
		<SubMenu key="2" title={
			<span><i className="anticon anticon-team" /> Report</span>
		}>
				<Item key="2.0">
				<	Typography.Link href="https://rsp.olympiatrust.com/forms.html" target="_blank"><i className="anticon anticon-home"/>Monthly Statement</Typography.Link>
				</Item>
				<Item key="2.1">
				<	Typography.Link href="https://www-us.computershare.com/Investor/#Help/PrintableForms" target="_blank"><i className="anticon anticon-home"/>Tax Slip</Typography.Link>
				</Item>
		</SubMenu> 
}
 */}
{
	this.state.isAuthenticated &&
		<SubMenu key="6" title={
			<span><i className="anticon anticon-team" /> Settings</span>
		}>
			<Item key="6.0">
				<Link to={'/profile'} replace ><i className="anticon anticon-home"/>Profile</Link>
			</Item>
{/* 							<Item key="6.1">
				<i className="anticon anticon-home"/>Change Password
			</Item>
*/}						</SubMenu> 
}
	

	</Menu>
	);

	render() {
		const timestamp = new Date().toISOString();
		console.log(`[${timestamp}] App render() called - loading:`, this.state.loading, 'isAuthenticated:', this.state.isAuthenticated, 'userType:', this.state.userType);
		
		// Show loading while checking authentication
		if (this.state.loading) {
			return (
				<div style={{ 
					display: 'flex', 
					justifyContent: 'center', 
					alignItems: 'center', 
					height: '100vh',
					fontSize: '18px'
				}}>
					Checking authentication...
				</div>
			);
		}

		return (
			<BrowserRouter>
			<NavBar menu={this.Menu()} />
     		<Layout>
       			 <SideBar menu={this.Menu()} />


				<Layout >
					<Content style={{ margin: '0 16px' }}>						<Switch>
							<Route exact path="/" >
								{(() => {
									console.log('Route "/" - isAuthenticated:', this.state.isAuthenticated, 'userType:', this.state.userType);
									if (this.state.isAuthenticated) {
										if (this.state.userType === 'emd') {
											console.log('Redirecting EMD user to /emd-portfolio');
											return <Redirect to="/emd-portfolio" />;
										} else if (this.state.userType === 'admin') {
											console.log('Redirecting admin user to /admin-portfolio');
											return <Redirect to="/admin-portfolio" />;
										} else {
											console.log('Redirecting advisor user (or null userType) to /clients. UserType was:', this.state.userType);
											return <Redirect to="/clients" />;
										}
									} else {
										console.log('User not authenticated, redirecting to /login');
										return <Redirect to="/login" />;
									}
								})()}
			            </Route>							
							<Route exact path={'/login'} component={() => {
								console.log('Route "/login" - isAuthenticated:', this.state.isAuthenticated, 'userType:', this.state.userType);
								// If user is already authenticated, redirect them away from login
								if (this.state.isAuthenticated) {
									if (this.state.userType === 'emd') {
										console.log('Authenticated EMD user accessing login, redirecting to /emd-portfolio');
										return <Redirect to="/emd-portfolio" />;
									} else if (this.state.userType === 'admin') {
										console.log('Authenticated admin user accessing login, redirecting to /admin-portfolio');
										return <Redirect to="/admin-portfolio" />;
									} else {
										console.log('Authenticated advisor user accessing login, redirecting to /clients');
										return <Redirect to="/clients" />;
									}
								}
								return <Login 
									setAuthenticate={this.setAuthenticate} 
									setCurrentUser={this.setCurrentUser} 
									setAuthenticationState={this.setAuthenticationState}
									isAuthenticated={this.state.isAuthenticated}
								/>;
							}} />		
							<Route exact path={'/register'} component={Register} />
 							<Route exact path={'/profile'} component={() => <Profile isAuthenticated={[this.state.isAuthenticated, this.state.currentUser]}/>} />
							<Route exact path={'/clients'} render={this.renderClients} />
		{/* 					<Route exact path={'/portfolio'} component={() => <Clients isAuthenticated= {[this.state.isAuthenticated, this.state.currentUser]} />} />
		 */}					<Route exact path={'/emd-portfolio'} render={this.renderEMDPortfolio} />
							<Route exact path={'/admin-portfolio'} render={this.renderAdminPortfolio} />
 							<Route exact path={'/resetPassword'} component={ResetPassword} />
							<Route exact path={'/changeProfile'} component={ChangeProfile} />
						</Switch>
					</Content>						
				</Layout>				
			</Layout>
			{this.state.isAuthenticated && (
				<ChatbotWidget userEmail={this.state.currentUser} userType={this.state.userType} />
			)}
			</BrowserRouter>
	)}
}
 
export default App; 

